module.exports = __webpack_public_path__ + "media/insights/television_icon-ef1eac12.png";